import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-heating-cooling',
  templateUrl: './icon-heating-cooling.component.html',
  styleUrls: ['./icon-heating-cooling.component.scss']
})
export class IconHeatingCoolingComponent implements OnInit {

  @Input() cssClass = 'icon--18';

  constructor() { }

  ngOnInit() {
  }

}
